import { orderBy } from 'lodash';
import { PersonUserData } from 'common/constants/types';

export const orderSearchResults = (searchResult: PersonUserData[]) =>
  orderBy(
    searchResult,
    [
      result => {
        const userInfoGenre = result.genres.find(e => e.name === 'user-info');
        if (!userInfoGenre) return undefined;

        const personalSection = userInfoGenre.sections.find(e => e.name === 'personal');
        if (!personalSection) return undefined;

        const nameAttrType = personalSection.attribute_types.find(e => e.name === 'name');
        if (!nameAttrType) return undefined;

        const userName = nameAttrType.attributes[0].value as string;
        return userName.toLowerCase();
      },
    ],
    ['asc']
  );
